<template>
    <div class="footer">
        <!-- <p>主办单位：河南省发展和改革委员会</p> -->
        <p><a href="https://www.dahe.cn/">技术支持：大河网</a></p>
    </div>
</template>

<script>
export default {
    name: 'footer_com',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
.footer{
    margin: 84px auto 0;
    text-align: center;
    p{
        opacity: 0.8;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 26px;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        line-height: 40px;
    }
    a{
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 26px;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        line-height: 40px;
    }

}
</style>